// import Vue from 'vue';
import moment from 'moment';

moment().locale('ru');
